import type { ISerialize } from '@/objects/ISerialize';
import { TransferLine } from './TransferLine';

export class TransferResponse implements ISerialize {
    public EventID: number;

    public RaceContestantIDsToRemove: number[];

    public TransferLines: TransferLine[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { EventID?: number; RaceContestantIDsToRemove?: number[]; TransferLines?: TransferLine[] }) {
        this.EventID = values.EventID ?? 0;

        this.RaceContestantIDsToRemove = values.RaceContestantIDsToRemove ?? [];

        this.TransferLines = values.TransferLines ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"RaceContestantIDsToRemove": [ ${this.RaceContestantIDsToRemove.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"TransferLines": [ ${this.TransferLines.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of TransferResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        EventID?: number;
        RaceContestantIDsToRemove?: number[];
        TransferLines?: TransferLine[];
    }): TransferResponse {
        return new TransferResponse(values);
    }

    public static _FromServerJson(json: any): TransferResponse {
        return new TransferResponse({
            EventID: json.EventID,
            RaceContestantIDsToRemove: json.RaceContestantIDsToRemove,
            TransferLines: json.TransferLines?.map((x: any) => TransferLine._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of TransferResponse from another instance of TransferResponse.
     * @param other The TransferResponse you want to clone
     * @returns A cloned TransferResponse
     */
    public static FromOther(other: TransferResponse): TransferResponse {
        return TransferResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return TransferResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'TransferResponse';
}
